module.exports = __webpack_public_path__ + "img/lbn.e33a49a9.svg";